export default __webpack_public_path__ + "static/media/right.ab184578.svg";